import React, { useEffect, useRef, useState } from "react";
import { MoreHoriz as MoreHorizIcon } from "@material-ui/icons";
import {
  Button as MuiButton,
  IconButton,
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
  MenuList,
  MenuItem,
} from "@material-ui/core";

const SrDropdown = ({ children, actions, useIconButton, ...props }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const Button = !children || useIconButton ? IconButton : MuiButton;

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef?.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleListKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  };

  const prevOpen = useRef(open);

  useEffect(() => {
    if (prevOpen.current && !open) {
      anchorRef?.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <div>
      <Button
        ref={anchorRef}
        aria-controls={open && "menu-list"}
        aria-haspopup="true"
        onClick={handleToggle}
        {...props}
      >
        {children || <MoreHorizIcon />}
      </Button>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        transition
        disablePortal
        style={{ zIndex: 1000 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="menu-list"
                  onKeyDown={handleListKeyDown}
                >
                  {actions?.map(({ onClick, content, key }) => (
                    <MenuItem
                      onClick={(event) => {
                        onClick();
                        handleClose(event);
                      }}
                      key={key}
                    >
                      {content}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
};

export default SrDropdown;
